import Path from "@core/FileProvider/Path/Path";
import { addScopeToFolderPath, splitScopedFolderPath } from "@ext/versioning/addScopeToPath";

// The diff view loads the article twice, from two independent fetches: the document shown in the
// editable pane comes from the diff item (`getDiffItemContent` for the item's path), while the save
// target — `articleProps.ref.path`, which every write URL is built from — comes from the scoped
// article context. While those two disagree, saving writes one article's body over another article's
// file, and the overwritten file is a real, unrelated article. Compare them before every write.
//
// Only the catalog folder may carry a scope (`<catalog folder>:<scope>/…` in a revision/HEAD context);
// the paths inside the catalog must match exactly, `:` in a file name included.
export const matchesDiffArticle = (catalogPath: string, loadedArticlePath: string, diffItemPath: string): boolean => {
	if (!loadedArticlePath || !diffItemPath) return false;
	const folder = addScopeToFolderPath(new Path(catalogPath));
	const loaded = splitScopedFolderPath(folder, new Path(loadedArticlePath));
	const target = splitScopedFolderPath(folder, new Path(diffItemPath));
	return !!loaded && !!target && loaded.relative.value === target.relative.value;
};

export default matchesDiffArticle;
